import RemoteLogClient from '@cvent/nucleus-remote-log-client';

export default RemoteLogClient;
